import { mergeStyleSets } from '@uifabric/merge-styles';
import { pxToRem } from '../../utils';

export default mergeStyleSets({
  approvalLabel: {
    fontWeight: 'normal',
  },
  loadingSpinner: {
    marginLeft: pxToRem(10),
  },
});
